<template>
  <section class="ELYXFAQ">
    <h2 class="ELYXFAQ__title">Frequently Asked Questions</h2>
    <div class="ELYXFAQ__qa">
      <div v-for="(q, index) in questions" :key="index" class="ELYXFAQ__question" @click="openQuestion(index)">
        <div class="ELYXFAQ__question--header">
          <div class="ELYXFAQ__question--text">{{ q.question }}</div>
          <div class="ELYXFAQ__question--expansion">
            <BottomArrow :class="index === selectedQuestionIndex ? 'ELYXFAQ__question--expansion--open' : ''" />
          </div>
        </div>
        <div class="ELYXFAQ__answer" :class="index === selectedQuestionIndex ? 'ELYXFAQ__answer--open' : ''">
          {{ q.answer }}
        </div>
      </div>
    </div>
    <div class="ELYXFAQ__more">
      Have more questions?
      <router-link class="ELYXFAQ__contact" to="/information/contact" title="Contact us for more information">Reach out</router-link>.
    </div>
  </section>
</template>

<script>
export default {
  components: {
    BottomArrow: () => import("../ELYXIcons/BottomArrow.vue"),
  },
  props: {
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedQuestionIndex: null,
    };
  },
  methods: {
    openQuestion(index) {
      if (this.selectedQuestionIndex === index) {
        this.selectedQuestionIndex = null;
      } else {
        this.selectedQuestionIndex = index;
      }
    },
  },
};
</script>

<style>
.ELYXFAQ {
  width: calc(100% - 20px);
  border-radius: 16px;
  margin: 0px 10px;
  margin-top: 30px;
  padding: 85px 0px;
}
.ELYXFAQ__title {
  text-align: center;
  font-size: 35px;
  margin-bottom: 60px;
}
.ELYXFAQ__qa {
  margin-bottom: 12px;
}
.ELYXFAQ__question {
  padding: 18px 15px;
  margin: 0px auto;
  margin-bottom: 12px;
  border: 1px solid transparent;
  border-radius: 20px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: #ffffff8a;
  position: relative;
  max-width: 660px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.ELYXFAQ__question:hover {
  background-color: white;
}
.ELYXFAQ__question--header {
  display: flex;
  align-items: center;
}
.ELYXFAQ__question--text {
  flex: 1;
  color: #333;
  font-size: 17px;
  font-weight: 500;
}
.ELYXFAQ__question--expansion svg {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  fill: #555;
}
.ELYXFAQ__question--expansion--open {
  transform: rotate(180deg);
}
.ELYXFAQ__more {
  text-align: center;
  margin-top: 35px;
  font-size: 17px;
  color: #555;
}
.ELYXFAQ__contact {
  color: #555;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.ELYXFAQ__contact:visited {
  color: #555;
}
.ELYXFAQ__contact:hover {
  color: #888;
}
.ELYXFAQ__answer {
  height: 0;
  overflow: hidden;
  opacity: 0;
  color: #333;
  transition: 0.3s ease;
}
.ELYXFAQ__answer--open {
  height: auto;
  opacity: 1;
  margin-top: 10px;
  line-height: 24px;
}
@media (max-width: 768px) {
  .ELYXFAQ {
    padding: 5rem 1rem;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
  }
  .ELYXFAQ__title {
    line-height: 120%;
    margin-bottom: 40px;
  }
  .ELYXFAQ__question {
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 16px;
  }
  .ELYXFAQ__question--text {
    font-size: 17px;
    line-height: 140%;
  }
}
</style>
